"use client";
import React from "react";
import Link from "next/link";
import getBlogs from "@/app/lib/getBlogs";
import { useState, useEffect } from "react";
import JustDropped from "../../Components/droppedJust/page";

export default function page({data}) {

  return (
    <div>
      <div className="m-20 max-sm:mx-5">
       
        <div>
          <div className="grid grid-cols-8 gap-[5%] max-ipad:grid-cols-1">
            <div className="col-span-2 max-ipad:col-span-1">
              <JustDropped />
            </div>
{data && Array.isArray(data) && data.length > 0 &&
      <Link
              href={`/ReadBlog/${data[0]?._id}`}
              className="col-span-4 max-ipad:col-span-1"
            >
              <div className="bg-[#ffffff] border cursor-pointer p-5 pb-14  h-fit shadow-lg ">
                <img
                  src={data[0]?.thumbnail}
                  alt="cinema drip movie thumbnail"
                  className=" w-full m-auto block h-[500px]"
                />
                <h1 className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] bg-clip-text text-transparent poppins capitalize text-center leading-tight mt-2 text-[32px] font-semibold">
                  {data[0]?.category}
                </h1>
                <div className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] h-1 w-24 m-auto" />
                <h3 className="text-[#011826] font-semibold poppins text-[32px] text-center mt-2 capitalize">
                  {data[0]?.title}
                </h3>
                <p className="text-[#011826] text-center mt-2 text-[16px] poppins">
                  {data[0]?.subtitle}
                </p>
              </div>
            </Link>}
            <div className=" col-span-2 max-ipad:col-span-1">
              {data &&
                Array.isArray(data) &&
                data.length > 0 &&
                data?.slice(1, 3).map((data, index) => (
                  <Link href={`/ReadBlog/${data?._id}`}>
                    <div key={index} className=" mb-5">
                      <img
                        src={data?.thumbnail}
                        alt=""
                        className=" w-full block h-[240px]"
                      />
                      <h1 className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] bg-clip-text text-transparent poppins capitalize text-center leading-tight mt-2 text-[16px] font-semibold">
                        {data?.category}
                      </h1>
                      <p className="text-[24px] font-medium poppins text-center">
                        {data?.title}
                      </p>
                      <p className="text-center uppercase font-[300] mt-1">
                        BY&nbsp;{data?.author}
                      </p>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
